// Selecting DOM elements
const dateRangeElement = document.querySelector('.js-gsfc-date-range-filter');
const dateRangeElementExists = dateRangeElement !== null ? true : false;
const dateFrom = document.querySelector('.js-gsfc-date-filter-from');
const dateTo = document.querySelector('.js-gsfc-date-filter-to');

// Create date picker instance
let datePicker;

/**
 * Initialize the date picker and set up event listeners.
 *
 * @param {Function} callback Function to call after processing events.
 */
const init = async (callback) => {
	if (dateFrom) {
		// Event listener for 'from' date input changes
		dateFrom.addEventListener('change', async function () {
			// Scroll to feed anchor with smooth behavior
			document.getElementById('filterWrapper').scrollIntoView({
				behavior: 'smooth',
			});
			await processFromDateChange(this); // Process 'from' date change
			callback(); // Call callback function
		});
	}

	if (dateTo) {
		// Event listener for 'to' date input changes
		dateTo.addEventListener('change', async function () {
			// Scroll to feed anchor with smooth behavior
			document.getElementById('filterWrapper').scrollIntoView({
				behavior: 'smooth',
			});
			await processToDateChange(this); // Process 'to' date change
			callback(); // Call callback function
		});
	}
};

/**
 * Process 'from' date input change.
 *
 * @param {Object} elem DOM element representing the 'from' date input element.
 * @return {Promise} Promise that resolves after processing the change.
 */
const processFromDateChange = (elem) => {
	return new Promise((resolve) => {
		global.filters.date_range_from = elem.value; // Update 'from' date in filters
		resolve();
	});
};

/**
 * Process 'to' date input change.
 *
 * @param {Object} elem DOM element representing the 'to' date input element.
 * @return {Promise} Promise that resolves after processing the change.
 */
const processToDateChange = (elem) => {
	return new Promise((resolve) => {
		global.filters.date_range_to = elem.value; // Update 'to' date in filters
		resolve();
	});
};

/**
 * Update date inputs based on global filter values.
 */
const update = () => {
	if (!dateRangeElementExists) {
		return;
	}

	if (dateFrom) {
		// Update 'from' date input
		if (
			global.filters.date_range_from !== undefined &&
			global.filters.date_range_from !== ''
		) {
			dateFrom.value = global.filters.date_range_from;
			const fromDateObj = new Date(global.filters.date_range_from);
			if (dateRangeElementExists) {
				datePicker.setStartDate(fromDateObj); // Set start date in date picker
			}
		} else {
			dateFrom.value = '';
		}
	}

	if (dateTo) {
		// Update 'to' date input
		if (
			global.filters.date_range_to !== undefined &&
			global.filters.date_range_to !== ''
		) {
			dateTo.value = global.filters.date_range_to;
			const toDateObj = new Date(global.filters.date_range_to);
			if (dateRangeElementExists) {
				datePicker.setEndDate(toDateObj); // Set end date in date picker
			}
		} else {
			dateTo.value = '';
		}
	}
};

// Export initialization and update functions for external use
export default { init, update };
